import { action } from 'typesafe-actions';
import ActionTypes from 'store/usuarios/actionTypes';
import { RequestStatus } from 'types';
import { PerfilesUsuario, InfoUser, FiltroPractica  } from 'store/usuarios/types';
import { CursoPractica, Sociedad } from 'store/practicas/types';

// Reset reducer
export const resetState = () => action(ActionTypes.RESET_STATE);

// Set reducer
export const setPerfilesUsuario = (payload: PerfilesUsuario) =>
  action(ActionTypes.SET_PERFILES_USUARIO, payload);

export const setInfoUsers = (payload: InfoUser[]) =>
  action(ActionTypes.SET_INFO_USERS, payload);

// Requests
export const getPerfilesUsuarioRequest = () =>
  action(ActionTypes.GET_PERFILES_USUARIO_REQUEST);

export const getInfoUsersRequest = () =>
  action(ActionTypes.GET_INFO_USERS_REQUEST);

// Requests statuses
export const setGetPerfilesUsuarioRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_PERFILES_USUARIO_REQUEST_STATUS, payload);

export const setGetInfoUsersRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GET_INFO_USERS_REQUEST_STATUS, payload);

// User photo
export const getUserPortraitRquest = () =>
  action(ActionTypes.GET_USER_PORTRAIT_REQUEST);

export const postUpdateConsent = () => action(ActionTypes.POST_UPDATE_CONSENT);

export const setPostUpdateConsent = (payload: RequestStatus) =>
  action(ActionTypes.SET_POST_UPDATE_CONSENT, payload);

export const setUserPortraitRquest = (payload: string) =>
  action(ActionTypes.SET_USER_PORTRAIT_REQUEST, payload);

export const setUserPortraitDataRquest = (payload: any) =>
  action(ActionTypes.SET_USER_PORTRAIT_DATA_REQUEST, payload);

export const getAlumnPortraitRequest = (alumnoId: string) =>
  action(ActionTypes.GET_ALUMN_PORTRAIT_REQUEST, alumnoId);

export const setAlumnPortraitRquest = (payload: string) =>
  action(ActionTypes.SET_ALUMN_PORTRAIT_REQUEST, payload);

export const updateUserPortraitRquest = (payload: string) =>
  action(ActionTypes.UPDATE_USER_PORTRAIT_REQUEST, payload);

export const deleteUserPortraitRquest = () =>
  action(ActionTypes.DELETE_USER_PORTRAIT_REQUEST);

export const setUpdateUserPortraitRquestStatus = (payload: RequestStatus) =>
  action(ActionTypes.UPDATE_USER_PORTRAIT_REQUEST_STATUS, payload);

export const setDeleteUserPortraitRquestStatus = (payload: RequestStatus) =>
  action(ActionTypes.DELETE_USER_PORTRAIT_REQUEST_STATUS, payload);

//Filtros
export const getFiltros = (payload) =>
  action(ActionTypes.GET_FILTROS, payload);
export const getFiltrosRequest = () =>
  action(ActionTypes.GET_FILTROS_REQUEST);
export const setFiltros = (payload: FiltroPractica[]) =>
  action(ActionTypes.SET_FILTROS, payload);
export const guardarFiltroRequest = (nombrePagina, filtroJson) =>
  action(ActionTypes.GUARDAR_FILTRO_REQUEST, nombrePagina, filtroJson);
export const eliminarFiltroRequest = (payload: string) =>
  action(ActionTypes.ELIMINAR_FILTRO_REQUEST, payload);
export const editarFiltroRequest = (nombrePagina, filtro) =>
  action(ActionTypes.EDITAR_FILTRO_REQUEST, nombrePagina, filtro);
export const setEliminarFiltroRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_ELIMINAR_FILTRO_REQUEST_STATUS, payload);
export const setGuardarFiltroRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_GUARDAR_FILTRO_REQUEST_STATUS, payload);
export const setEditarFiltroRequestStatus = (payload: RequestStatus) =>
  action(ActionTypes.SET_EDITAR_FILTRO_REQUEST_STATUS, payload);
export const setFiltroId = (payload: string) =>
  action(ActionTypes.SET_FILTRO_ID, payload);
export const setFiltroNombre = (payload: string) =>
  action(ActionTypes.SET_FILTRO_NOMBRE, payload);
export const setFiltroFechaCreacion = (payload: number) =>
  action(ActionTypes.SET_FILTRO_FECHA_CREACION, payload);
export const setFiltroFechaModificacion = (payload: number) =>
  action(ActionTypes.SET_FILTRO_FECHA_MODIFICACION, payload);
export const setFiltroNombrePagina = (payload: string) =>
  action(ActionTypes.SET_FILTRO_NOMBRE_PAGINA, payload);
export const setFiltroJson = (payload: string) =>
  action(ActionTypes.SET_FILTRO_JSON, payload);
export const setCursosPractica = (payload: CursoPractica[]) =>
  action(ActionTypes.SET_CURSOS_FILTRO, payload);
export const setSociedadesFiltro = (payload: Sociedad[]) =>
  action(ActionTypes.SET_SOCIEDADES, payload);

export const removeFiltro = () =>
  action(ActionTypes.REMOVE_FILTRO);

//panel administracion
export const getAllUsuarios = () =>
  action(ActionTypes.GET_ALL_USUARIOS);
export const setAllUsuarios = (payload) =>
  action(ActionTypes.SET_ALL_USUARIOS, payload);
export const setGetAllUsuariosRequestStatus = (payload) =>
  action(ActionTypes.SET_GET_ALL_USUARIOS_REQUEST_STATUS, payload);

export const insertarUsuarioPerfil = (payload) =>
  action(ActionTypes.INSERTAR_USUARIO_PERFIL, payload);

export const setInsertarUsuarioPerfilRequestStatus = (payload) =>
  action(ActionTypes.SET_INSERTAR_USUARIOS_PERFIL_REQUEST_STATUS, payload);

export const habilitarUsuarioPerfil = (payload) =>
  action(ActionTypes.HABILITAR_USUARIO_PERFIL, payload);

export const setHabilitarUsuarioPerfilRequestStatus = (payload) =>
  action(ActionTypes.SET_HABILITAR_USUARIO_PERFIL_REQUEST_STATUS, payload);

export const eliminarUsuarioPerfil = (payload) =>
  action(ActionTypes.ELIMINAR_USUARIO_PERFIL, payload);


export const setEliminarUsuarioPerfilRequestStatus = (payload) =>
  action(ActionTypes.SET_ELIMINAR_USUARIOS_PERFIL_REQUEST_STATUS, payload);


